import React from 'react';

import UFOSegment from '@atlaskit/react-ufo/ufo-segment';
import { AtlassianRelayEnvironmentProvider } from '@atlassian/relay-environment-provider';

import { ConversationAssistantConfigurer } from './ConversationAssistantConfigurer';

export const ConversationAssistant = ({
	skipRelayProvider,
	...props
}: Parameters<typeof ConversationAssistantConfigurer>[0] & {
	skipRelayProvider?: boolean;
}): React.JSX.Element => {
	// Mounts that skip the chat UI still initialise the shared providers, the global chat store and the
	// bridge API handlers. `overridingChildren` is the legacy signal for the same intent, so it keeps
	// implying the chat UI is skipped.
	const shouldSkipChatUI = props.skipChatUI ?? Boolean(props.overridingChildren);

	const rootSegmentName = shouldSkipChatUI
		? 'rovo-conversation-assistant-wOverriddenChildren'
		: 'rovo-conversation-assistant';

	const content = <ConversationAssistantConfigurer {...props} />;

	return (
		// The UFOSegment has to be absolute top, please do not introduce any side effects in this parent level component,
		// otherwise it may not get captured with performance metrics
		<UFOSegment name={rootSegmentName}>
			{skipRelayProvider ? (
				content
			) : (
				<AtlassianRelayEnvironmentProvider>{content}</AtlassianRelayEnvironmentProvider>
			)}
		</UFOSegment>
	);
};
